import {Route, Routes} from 'react-router-dom';
import LeavesStack from 'navigation/LeavesStack';

const PalowanStack = () => {
  return (
    <Routes>
      <Route path="leaves/*" element={<LeavesStack />} />
    </Routes>
  );
};

export default PalowanStack;
